import React, { useState, useEffect } from 'react'
import styled from '@emotion/styled';
import { connect } from 'react-redux';
import { device } from '../../../../components/Print/device';
import _get from 'lodash.get';
import _isEqual from 'lodash.isequal';
import PrintArticleShowInner from './PrintArticleShowInner';
import { fireCustomDimension, fireGA4Script, fireGA4ScriptPerpectual, fireGA4WithDataObject } from 'utils/common';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import { loadArticleshowData, updateActiveMsid } from 'routes/printarticleshow/redux';
import ArticleSidebar from './PrintPerpetualBox';
import { IParams } from 'routes/printarticleshow/printASutils';
import { PRC_FOR_SUBSCRIBED, TOI_DEFAULT_IMAGE_MSID } from 'constants/index';
import { fetchUserSubscriptionStatusFromApi, getPrcCookieValue } from 'utils/primeUtil';

interface IUserData {
    isLoggedIn?: boolean;
    prcValue?: number;
    showConsentPopUp?: boolean;
}

interface IStyledDivider {
    theme: { [key: string]: any };
}

interface IPrintArticleShowProps {
    allArticleData?: { [key: string]: any };
    parentMsid: string;
    isWapView: boolean;
    userData?: IUserData
    urlPath: string
    isUserPrime: boolean
    storyTitle: string
    isAppView: boolean;
    dataLoading?: boolean
    getArticleshowData?: (params: IParams) => void
    updateActiveMsid?: (val: string) => void
    params: IParams
    moreStories: { [key: string]: any }[]
    userPrcData?: any;
    isEPaper: boolean;
    isEpaperApp: boolean;
}


const PrintArticleShow = (props: IPrintArticleShowProps) => {
    const { allArticleData, parentMsid, isWapView, urlPath, isUserPrime, storyTitle, isAppView, userData, dataLoading, getArticleshowData, updateActiveMsid, params, moreStories, userPrcData, isEPaper, isEpaperApp } = props;
    const [enablePerpetual, setEnablePerpetual] = useState<boolean>(false);
    const [isFooterVisible, setIsFooterVisible] = useState<boolean>(false);
    const [articlesLoaded, isArticlesLoaded] = useState<boolean>(false);
    const [pageViewFiredArr, setPageViewFiredArr] = useState<{ [key: string]: any }[]>([]);
    const [activeMsid, setActiveMsid] = useState<string>(parentMsid);
    const [isBlocked, setIsBlocked] = useState<boolean>(isEpaperApp ? false : true);
    const [isUpgrade, setIsUpgrade] = useState<boolean>(false);
    const categoryForGA = isWapView ? 'WAP-Printedprimeshow' : 'WEB-Printedprimeshow';
    let nextLinksData = moreStories;
    const inViewThreshold = 1;
    if (nextLinksData && nextLinksData.length > 0) {
        const perpetualStoriesToLoad = Math.min(3, nextLinksData.length);
        nextLinksData = nextLinksData.slice(0, perpetualStoriesToLoad);
    }
    let articleshowData
    if (allArticleData && allArticleData[parentMsid]) {
        articleshowData = allArticleData[parentMsid];
    }
    useEffect(() => {
        const options = {
            threshold: inViewThreshold
        }
        const observer = new IntersectionObserver(changePageUrl, options);
        const sections = document.querySelectorAll("[data-articlemsid]");
        sections.forEach((section) => {
            observer.observe(section);
        });
        return () => {
            sections.forEach((section) => {
                observer.unobserve(section);
            });
        }
    }, [typeof document !== 'undefined' ? document.querySelectorAll("[data-articlemsid]") : false])

    useEffect(() => {
        if (allArticleData && allArticleData[parentMsid]) {
            analyticsWrapper('ga', 'send', 'event', categoryForGA, 'landing', `ps_story_0-${allArticleData[parentMsid].wu}`)
        }
        fireGA4WithDataObject(fireGA4Script({ isEpaper: true, vmsid: parentMsid, storyNumber: '0' }) || {});
        const observer2 = new IntersectionObserver(entry => {
            setIsFooterVisible(entry[0].isIntersecting);
        });
        const footerDiv = document.getElementsByClassName("printFooter");
        if (!isWapView && footerDiv && footerDiv[0]) {
            observer2.observe(footerDiv[0]);
        }
        return () => {
            if (!isWapView) {
                observer2.unobserve(footerDiv[0]);
            }
        }
    }, [])

    useEffect(() => {
        checkIsEpaperSubscribed();
    }, [userData, userPrcData]);

    const checkIsEpaperSubscribed = () => {
        const prcValue = getPrcCookieValue();





        if (isEPaper) {

            if (isEpaperApp) {
                setIsBlocked(false);
                if (!enablePerpetual && !isAppView) {
                    setEnablePerpetual(true);
                }
                if (!articlesLoaded && !dataLoading) {
                    loadRelatedArticles();
                }
            } else if (!isEpaperApp && userData && userData.isLoggedIn && userPrcData) {
                // fetchUserSubscriptionStatusFromApi(userPrcData).then(data => {
                if (Array.isArray(userPrcData.accessibleFeatures) && userPrcData.accessibleFeatures.includes("TOIPRED")) {
                    setIsBlocked(false);
                    if (!enablePerpetual && !isAppView) {
                        setEnablePerpetual(true);
                    }
                    if (!articlesLoaded && !dataLoading) {
                        loadRelatedArticles();
                    }
                } else if ((isUserPrime || prcValue === PRC_FOR_SUBSCRIBED || userPrcData.planStatus === PRC_FOR_SUBSCRIBED)) {
                    setIsBlocked(true);
                    setIsUpgrade(true);
                } else {
                    setIsBlocked(true);
                }
                // });
            } else {
                setIsBlocked(true);
            }

        } else if ((isUserPrime || prcValue === PRC_FOR_SUBSCRIBED)) {
            setIsBlocked(false);
            if (!enablePerpetual && !isAppView) {
                setEnablePerpetual(true);
            }
            if (!articlesLoaded && !dataLoading) {
                loadRelatedArticles();
            }
        } else {
            setIsBlocked(true);

        }
    }

    const loadRelatedArticles = () => {
        if (Array.isArray(moreStories) && moreStories.length) {
            for (let i = 0; i < moreStories.length; i += 1) {
                let msid = moreStories[i].id;
                getArticleshowData?.({ ...params, msid });
                isArticlesLoaded(true);
            }
        }
    };

    const getAuthorsName = (authorsData: { [key: string]: any }[]) => {
        if (!authorsData) {
            return '';
        }
        const authorsNames: { [key: string]: any }[] = [];
        authorsData.forEach(authorData => {
            const name = authorData?.name;
            if (!authorsNames.includes(name)) {
                authorsNames.push(name);
            }
        });
        return authorsNames.join(' and ');
    };

    const changePageUrl = (entries: any, observer: any) => {
        entries.every((entry: any) => {
            if (entry.isIntersecting && entry.intersectionRatio >= inViewThreshold) {
                const nextMsid = entry.target.getAttribute("data-articlemsid");
                const storyNumber = entry.target.getAttribute("data-index");
                if (activeMsid === nextMsid) {
                    return;
                }
                let nextDataUrl = allArticleData ? allArticleData[nextMsid].wu : '';
                const pageUrl = window.location.href.replace(origin, '');
                nextDataUrl = nextDataUrl
                    .replace('https://timesofindia.indiatimes.com', '')
                    .replace('https://toidev.indiatimes.com', '')
                    .replace('articleshow', 'printarticle') //remove
                if (pageUrl !== nextDataUrl) {
                    setActiveMsid(nextMsid);
                    updateActiveMsid?.(nextMsid);
                }
                const queryParameters = window.location.href.split('?')[1];
                nextDataUrl += queryParameters ? `?${queryParameters}` : '';
                window.history.pushState({}, '', nextDataUrl);
                if (allArticleData && allArticleData[nextMsid].seo) {
                    document.title = allArticleData[nextMsid].seo.title;
                }
                if (pageViewFiredArr.indexOf(nextMsid) === -1 && nextMsid !== parentMsid) {
                    fireCustomDimension(nextMsid, 'dimension31');
                    if (allArticleData && allArticleData[nextMsid]) {
                        fireCustomDimension(getAuthorsName(allArticleData[nextMsid]?.authors,), 'dimension4');
                        fireCustomDimension(allArticleData[nextMsid]?.ag, 'dimension5');
                        analyticsWrapper('ga', 'send', 'pageview', window.location.href);
                        setPageViewFiredArr(oldArray => [...oldArray, nextMsid]);
                        const articleshowData = allArticleData[nextMsid];
                        const sectionName = _get(articleshowData, 'navsubsecs.subsec1.subsecname1');
                        const subSection = _get(articleshowData, 'navsubsecs.subsec2.subsecname2');
                        const subsec3 = _get(articleshowData, 'navsubsecs.subsec3.subsecname3');
                        const subsec4 = _get(articleshowData, 'navsubsecs.subsec4.subsecname4');
                        const subsec5 = _get(articleshowData, 'navsubsecs.subsec5.subsecname5');
                        const subsec6 = _get(articleshowData, 'navsubsecs.subsec6.subsecname6');
                        const { ag, authors, dl } = articleshowData;
                        let authorName = ''
                        if (Array.isArray(authors) && authors.length > 0) {
                            authorName = authors[0].name;
                        }
                        fireGA4WithDataObject(fireGA4ScriptPerpectual({ isEpaper: true, vmsid: nextMsid, storyNumber, sectionName, subSection, subsec3, subsec4, subsec5, subsec6, authorName, agencyName: ag, dlTimeStamp: dl }) || {});
                    }
                }
                return false;
            }
        });
    }

    const getMoreArticles = () => {
        let comp = null;
        if (Array.isArray(nextLinksData) && nextLinksData.length) {
            comp = nextLinksData.map((val: { [key: string]: any }, index: number) => {
                if (allArticleData && allArticleData[val.id]) {
                    return (
                        <>
                            <DividerWrapper data-articlemsid={val.id} data-index={index + 1}>
                                <i />
                                <span>Up Next</span>
                            </DividerWrapper>
                            <PrintArticleShowInner isWapView={isWapView} msid={val.id} urlPath={urlPath} isUserPrime={!isBlocked} storyTitle={storyTitle} isAppView={isAppView} articleShowData={allArticleData[val.id]} userData={userData} categoryForGA={categoryForGA} isUpgrade={isUpgrade} isEpaperApp={isEpaperApp} />
                        </>
                    )
                }
            })
            return comp;
        }
    }
    return (
        <>
            {!isWapView && !isFooterVisible && !isBlocked && Array.isArray(nextLinksData) && nextLinksData.length ?
                <ArticleSidebar
                    nextLinksData={nextLinksData}
                    activeMsid={activeMsid}
                    allArticleData={allArticleData}
                    parentStory={{
                        su: articleshowData.su,
                        wu: articleshowData.wu,
                        msid: articleshowData.id,
                        value: articleshowData.hl,
                        images: articleshowData.images,
                        showImageInSideBar: articleshowData.images && articleshowData.images.length === 1 && articleshowData.images[0].id && articleshowData.images[0].id !== TOI_DEFAULT_IMAGE_MSID
                    }} /> : null}
            {allArticleData && allArticleData[parentMsid] &&
                <>
                    <section data-articlemsid={parentMsid} data-index={0} />
                    <PrintArticleShowInner isWapView={isWapView} msid={parentMsid} urlPath={urlPath} isUserPrime={!isBlocked} storyTitle={storyTitle} isAppView={isAppView} articleShowData={allArticleData[parentMsid]} userData={userData} categoryForGA={categoryForGA} isUpgrade={isUpgrade} isEpaperApp={isEpaperApp} />
                </>}
            {!isBlocked && getMoreArticles()}
        </>
    )
}

const mapDispatchToProps = (dispatch: any) => ({
    getArticleshowData: (params: IParams) => {
        dispatch(loadArticleshowData(params));
    },
    updateActiveMsid: (innerMsid: string) => {
        dispatch(updateActiveMsid(innerMsid));
    },
});

const cachedResultIfPresent = (function getCachedResultIfAvailable() {
    let cachedData = { geo: {}, userData: {} as IUserData };
    return (data: { geo: {}; userData: IUserData; }) => {
        if (!_isEqual(cachedData, data)) {
            cachedData = data;
        }
        return cachedData;
    };
})();

const mapStateToProps = (state: any, onProps: any) => ({
    allArticleData: _get(state, 'printeditionas.data', null),
    userData: cachedResultIfPresent({
        userData: _get(state, 'login.userData', {}),
        geo: _get(state, 'geo', null),
    })?.userData,
    dataLoading: state.printeditionas.dataLoading,
    moreStories: _get(state, `printeditionas.data[${onProps.parentMsid}].nextLinks`, []),
    userPrcData: state.login.userPrcData,
});

export default connect(mapStateToProps, mapDispatchToProps)(PrintArticleShow);

export const DividerWrapper = styled.section<IStyledDivider>`
    display: flex;
    align-items: center;
    margin: 50px auto 0 ;
    padding: 0 0 0 30px;
    position: relative;
    width:636px;
    
    i{
        background: #1a1a1a;
        border: 0;
        height: 5px;
        width: 100%;
        position: absolute;
        left: 0;
        border-radius: 10px;
    }
    span{
        background: var(--white-color);
        display: inline-block;
        font-size: 16px;
        padding: 0 10px;
        position: relative;
        font-weight: 700;
        text-transform: uppercase;

        &:after{
            border: 6px solid transparent;
            border-top: 6px solid #1a1a1a;
            bottom: -15px;
            content: "";
            height: 1px;
            left: 50%;
            margin-left: -6px;
            position: absolute;
        }
    }
    @media ${device.mobile}{
        width:100%;
        justify-content:center;
        padding:0;
    }
` 